import { Skeleton } from '../../../Skeleton'

import * as styles from './CalendarGridDayChipsSkeleton.module.css'

function CalendarGridDayChipsSkeleton() {
  return (
    <>
      <Skeleton className={styles.chip} />
      <Skeleton className={styles.chipShort} />
    </>
  )
}

export default CalendarGridDayChipsSkeleton
